import React from 'react';
import PropTypes from 'prop-types';
import CustomButton from '../../features/customButton/ui/main/CustomButton';
import CustomModal from '../../baseComponents/gui/customModal/CustomModal';
import { useModal } from '../../../hooks/useModal';
import { safeHTML } from '../../../utils/safeHTML';
import { icons } from '../../../constants/rewards';
import { image } from '../../../utils/data/baseUrl';
import { useCopy } from '../../../hooks/useCopy';
import { useTranslation } from '../../../translations';

const PromocodeModal = React.forwardRef(function PromocodeModal({ title, subtitle, text, buttons, promoCode }, ref) {
  const { closeModal, id } = useModal();
  const { t } = useTranslation();

  const [copyText, setCopyText, disabled] = useCopy(promoCode);

  const buttonCallbacks = {
    close() {
      closeModal({ id });
    },
  };

  return (
    <CustomModal className={'custom-modal_resource'} animation={['fade', 'block-scale-bounce']} isFullPage={true}>
      <div className={`promocode-modal`} ref={ref}>
        <div className={'promocode-modal__bg'} />

        <div className={'promocode-modal__content'}>
          <div className={'promocode-modal__image'}>
            <img src={image(icons.promo)} alt={''} />
          </div>

          <div className={'promocode-modal__title'}>{safeHTML(t(title))}</div>

          {promoCode && (
            <div className={'promocode-modal__promoCode-container'}>
              <span className={'promocode-modal__promoCode'}>{promoCode}</span>
              <button className={'promocode-modal__promoCode-button'} disabled={disabled} onClick={setCopyText}>
                {copyText}
              </button>
            </div>
          )}

          <div className={'promocode-modal__subtitle'}>{safeHTML(t(subtitle))}</div>

          <div className={'promocode-modal__text'}>{safeHTML(t(text))}</div>

          <div className={'promocode-modal__buttons'}>
            {buttons.map(({ attr, action }, id) => (
              <CustomButton key={`b-${id}`} {...attr} onClick={action && buttonCallbacks[action]} />
            ))}
          </div>
        </div>
      </div>
    </CustomModal>
  );
});

PromocodeModal.propTypes = {
  title: PropTypes.string,
  promoCode: PropTypes.string,
};

export default PromocodeModal;
